if (!customElements.get('product-form')) {
	customElements.define(
	  'product-form',
	  class ProductForm extends HTMLElement {
		constructor() {
		  super();
  
		  this.form = this.querySelector('form');
		  if (this.form) {
		  this.form.querySelector('[name=id]').disabled = false;
		  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		  }
		  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
		  this.submitButton = this.querySelector('[type="submit"]');
  
		  if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  
		  this.hideErrors = this.dataset.hideErrors === 'true';
		}
  
		onSubmitHandler(evt) {
		  evt.preventDefault();
		  if (this.submitting || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
		  const activeButton = evt.submitter || this.submitButton;
		  if (activeButton.disabled || activeButton.getAttribute('aria-disabled') === 'true') return;
		  const buyNow = activeButton.hasAttribute('data-buy-now');
		  if (buyNow && !this.form.reportValidity()) return;
		  const buyNowButton = this.querySelector('[data-buy-now]');
		  const spinner = activeButton.querySelector('.loading__spinner');
		  this.submitting = true;
		  this.error = false;
  
		  this.handleErrorMessage();
  
		  this.submitButton.setAttribute('aria-disabled', true);
		  if (buyNowButton) buyNowButton.setAttribute('aria-disabled', true);
		  activeButton.classList.add('loading');
  
		  if (spinner) {
			spinner.classList.remove('hidden');
		  }
  
		  const config = fetchConfig('javascript');
		  config.headers['X-Requested-With'] = 'XMLHttpRequest';
		  delete config.headers['Content-Type'];
  
		  const formData = new FormData(this.form);
		  if (this.cart && !buyNow) {
			formData.append(
			  'sections',
			  this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		  }
		  config.body = formData;
  
		  return fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
			  if (response.status) {
				publish(PUB_SUB_EVENTS.cartError, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  errors: response.errors || response.description,
				  message: response.message,
				});
				this.handleErrorMessage(response.description);
  
				const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
				if (!soldOutMessage) return;
				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.querySelector('span').classList.add('hidden');
				soldOutMessage.classList.remove('hidden');
				this.error = true;
				return;
			  } else if (buyNow) {
				// Keep the existing cart, variant, quantity and all submitted properties.
				// Payment selection (including COD) happens in the standard checkout.
				this.redirectingToCheckout = true;
				window.location.assign(activeButton.value);
				return;
			  } else if (!this.cart) {
				window.location = window.routes.cart_url;
				return;
			  }
  
			  if (!this.error)
				publish(PUB_SUB_EVENTS.cartUpdate, {
				  source: 'product-form',
				  productVariantId: formData.get('id'),
				  cartData: response,
				});
				
			  this.error = false;
			  const quickAddModal = this.closest('quick-add-modal');
			  if (quickAddModal) {
				document.body.addEventListener(
				  'modalClosed',
				  () => {
					setTimeout(() => {
					  this.cart.renderContents(response);
					});
				  },
				  { once: true }
				);
				quickAddModal.hide(true);
			  } else {
				this.cart.renderContents(response);
			  }
			})
			.catch((e) => {
			  console.error(e);
			  this.handleErrorMessage(window.cartStrings.error);
			})
			.finally(() => {
			  // Keep both buttons locked while leaving the page to avoid duplicate adds.
			  if (this.redirectingToCheckout) return;
			  this.submitting = false;
			  activeButton.classList.remove('loading');
			  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
			  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
			  if (buyNowButton) buyNowButton.removeAttribute('aria-disabled');
			  if (spinner) {
				spinner.classList.add('hidden');
			  }
			});
		}

		connectedCallback() {
		  this.onPageShow = () => {
			if (!this.redirectingToCheckout) return;
			this.redirectingToCheckout = false;
			this.submitting = false;
			this.querySelectorAll('[type="submit"]').forEach((button) => {
			  button.removeAttribute('aria-disabled');
			  button.classList.remove('loading');
			  button.querySelector('.loading__spinner')?.classList.add('hidden');
			});
		  };
		  window.addEventListener('pageshow', this.onPageShow);
		}

		disconnectedCallback() {
		  window.removeEventListener('pageshow', this.onPageShow);
		}
  
		handleErrorMessage(errorMessage = false) {
		  if (this.hideErrors) return;
  
		  this.errorMessageWrapper =
			this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
		  if (!this.errorMessageWrapper) return;
		  this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
		  this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
		  if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
		  }
		}
	  }
	);
  }
